if (!customElements.get('std-collection-filters')) {
  customElements.define('std-collection-filters', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.std-filter-panel');
      this.base = this.dataset.base;
      if (this.dataset.previewTheme) {
        for (const link of this.querySelectorAll('a[href]')) {
          const url = new URL(link.href, location.origin);
          if (url.origin === location.origin) {
            url.searchParams.set('preview_theme_id', this.dataset.previewTheme);
            link.href = url.href;
          }
        }
      }
      this.params = new URLSearchParams(location.search);
      this.pathTags = location.pathname.slice(this.base.length).split('/').filter(Boolean).join('/').split('+').filter(Boolean).map(decodeURIComponent);
      const selectedFlavours = this.params.getAll('filter.p.tag').flatMap(v => v.split(','));
      for (const input of this.form.querySelectorAll('input[data-values]')) {
        input.checked = input.name === 'flavour' ? input.dataset.values.split('~').some(v => selectedFlavours.includes(v)) : this.pathTags.includes(input.value) || input.dataset.values.split('~').some(v => selectedFlavours.includes(v));
      }
      for (const input of this.form.querySelectorAll('[name="filter.p.vendor"]')) input.checked = this.params.getAll(input.name).flatMap(v=>v.split(',')).includes(input.value);
      for (const input of this.form.querySelectorAll('[name="filter.p.product_type"]')) input.checked = input.value.split(',').every(v => this.params.getAll(input.name).includes(v)) || (!input.value && !this.params.has(input.name));
      for (const group of ['style', 'format', 'serves']) if (!this.form.querySelector('input[name="' + group + '"][data-values]:checked')) this.form.querySelector('input[name="' + group + '"][value=""]')?.setAttribute('checked','checked');
      if (this.form.querySelector('input[name="meal"]:checked')) for (const input of this.form.querySelectorAll('[name="filter.p.product_type"]')) input.checked = false;
      const media = matchMedia('(max-width: 767px)');
      this.panel.open = !media.matches;
      this.onMedia = event => { this.panel.open = !event.matches; };
      media.addEventListener('change', this.onMedia);
      this.media = media;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(); });
      this.querySelector('[data-std-sort]')?.addEventListener('change', () => this.apply());
      this.classList.add('std-auto-filtering');
      this.form.addEventListener('change', event => {
        if (event.target.name === 'meal') {
          for (const input of this.form.querySelectorAll('[name="filter.p.product_type"], [name="style"], [name="format"], [name="serves"]')) input.checked = false;
        }
        if (event.target.name === 'format' && event.target.value === 'whole-cake') for (const input of this.form.querySelectorAll('[name="meal"]')) input.checked = false;
        if (event.target.name === 'filter.p.product_type') for (const input of this.form.querySelectorAll('[name="meal"]')) input.checked = false;
        if (event.target.matches('input[type="radio"], input[type="checkbox"], input[type="number"]')) this.apply();
      });
      try {
        const saved = JSON.parse(sessionStorage.getItem('std-filter-navigation') || 'null');
        sessionStorage.removeItem('std-filter-navigation');
        const currentUrl = new URL(location.href);
        const savedUrl = saved && new URL(saved.url, location.origin);
        currentUrl.searchParams.delete('preview_theme_id');
        savedUrl?.searchParams.delete('preview_theme_id');
        if (saved && savedUrl.pathname + savedUrl.search === currentUrl.pathname + currentUrl.search) {
          this.panel.open = saved.panel;
          for (const group of this.querySelectorAll('.std-filter-group')) group.open = saved.groups.includes(group.querySelector('summary').textContent.trim());
          requestAnimationFrame(() => window.scrollTo(0, saved.scroll));
        }
      } catch {}
      this.renderSelected();
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.onMedia); }
    apply() {
      const params = new URLSearchParams(location.search);
      for (const key of [...params.keys()]) if (key.startsWith('filter.') || key === 'page' || key === 'section_id') params.delete(key);
      if (this.dataset.previewTheme) params.set('preview_theme_id', this.dataset.previewTheme);
      const tags = [];
      const flavours = [];
      for (const input of this.form.querySelectorAll('input[data-values]:checked')) {
        if (input.name === 'flavour') flavours.push(...input.dataset.values.split('~'));
        else if (input.value) tags.push(input.value);
      }
      for (const input of this.form.querySelectorAll('[name="filter.p.vendor"]:checked, [name="filter.p.product_type"]:checked')) if (input.value) for (const value of input.value.split(',')) params.append(input.name,value);
      for (const input of this.form.querySelectorAll('input[type="number"]')) if (input.value !== '') params.set(input.name,input.value);
      for (const flavour of [...new Set(flavours)]) params.append('filter.p.tag',flavour);
      const sort = this.querySelector('[data-std-sort]');
      if (sort) params.set('sort_by', sort.value);
      const path = this.base + (tags.length ? '/' + [...new Set(tags)].map(encodeURIComponent).join('+') : '');
      const query = params.toString();
      const destination = path + (query ? '?' + query : '');
      try {
        sessionStorage.setItem('std-filter-navigation', JSON.stringify({
          url: destination,
          panel: this.panel.open,
          groups: [...this.querySelectorAll('.std-filter-group[open]')].map(group => group.querySelector('summary').textContent.trim()),
          scroll: window.scrollY
        }));
      } catch {}
      this.setAttribute('aria-busy', 'true');
      location.assign(destination);
    }
    renderSelected() {
      const area = this.querySelector('.std-selected');
      for (const input of this.form.querySelectorAll('input:checked')) {
        if (!input.value) continue;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = (input.dataset.label || input.value) + ' ×';
        button.setAttribute('aria-label', this.dataset.remove.replace('{{ value }}', input.dataset.label || input.value));
        button.addEventListener('click', () => { input.checked = false; this.apply(); });
        area.append(button);
      }
    }
  });
}
